import { CourseItemSkeleton } from '../../components/courses/CourseItem'
import { CourseList } from '../../components/courses/CourseList'
import { FilterSkeleton } from '../../components/filter/FilterSkeleton'

export const CoursesSkeleton = () => {
  return (
    <>
      <FilterSkeleton />
      <CourseList>
        {[...Array(9)].map((e, i) => (
          <CourseItemSkeleton key={i + Date.now()} />
        ))}
      </CourseList>
    </>
  )
}
